/**
 * User Agent文字列をパースして構造化情報を抽出
 */
export interface ParsedUserAgent {
  browser: string;
  browserVersion: string;
  os: string;
  osVersion: string;
  deviceType: 'Desktop' | 'Mobile' | 'Tablet';
  isBot: boolean;
}

const BOT_PATTERNS = [
  /bot/i,
  /crawl/i,
  /spider/i,
  /scrape/i,
  /curl/i,
  /wget/i,
  /python-requests/i,
  /headless/i,
  /puppeteer/i,
  /selenium/i,
  /phantom/i
];

export function parseUserAgent(ua: string): ParsedUserAgent {
  return {
    browser: detectBrowser(ua),
    browserVersion: detectBrowserVersion(ua),
    os: detectOS(ua),
    osVersion: detectOSVersion(ua),
    deviceType: detectDeviceType(ua),
    isBot: BOT_PATTERNS.some(pattern => pattern.test(ua))
  };
}

function detectBrowser(ua: string): string {
  if (/Edg/.test(ua)) return 'Edge';
  if (/Chrome/.test(ua)) return 'Chrome';
  if (/Firefox/.test(ua)) return 'Firefox';
  if (/Safari/.test(ua) && !/Chrome/.test(ua)) return 'Safari';
  if (/Opera|OPR/.test(ua)) return 'Opera';
  return 'Unknown';
}

function detectBrowserVersion(ua: string): string {
  const matches = ua.match(/(Chrome|Firefox|Safari|Edg|OPR)\/([0-9.]+)/);
  return matches ? matches[2] : 'Unknown';
}

function detectOS(ua: string): string {
  if (/Windows NT/.test(ua)) return 'Windows';
  if (/Mac OS X/.test(ua)) return 'macOS';
  if (/Linux/.test(ua)) return 'Linux';
  if (/Android/.test(ua)) return 'Android';
  if (/iOS|iPhone|iPad/.test(ua)) return 'iOS';
  return 'Unknown';
}

function detectOSVersion(ua: string): string {
  const winMatch = ua.match(/Windows NT ([0-9.]+)/);
  if (winMatch) return winMatch[1];

  const macMatch = ua.match(/Mac OS X ([0-9_]+)/);
  if (macMatch) return macMatch[1].replace(/_/g, '.');

  const androidMatch = ua.match(/Android ([0-9.]+)/);
  if (androidMatch) return androidMatch[1];

  return 'Unknown';
}

function detectDeviceType(ua: string): 'Desktop' | 'Mobile' | 'Tablet' {
  if (/Mobi/.test(ua) && !/Tablet/.test(ua)) return 'Mobile';
  if (/Tablet|iPad/.test(ua)) return 'Tablet';
  return 'Desktop';
}
